<script setup>
const props = defineProps({
    automationId: {
        type: Number,
        required: true,
    },
})
</script>
<template>
    <div>
        <div class="md:sticky top-2 z-topbar">
            <frosted-bar>
                <div class="flex items-center justify-between space-x-4 f">
                    <div class="flex space-x-1 items-start">
                        <h1>
                            Deliveries
                        </h1>
                    </div>
                </div>

                <template #navigation>
                    <a
                        :href="route('bo.crm.automations.list')"
                        class="mf-link text-xs"
                    >
                        &larr; {{ _mft('communication:automation.domainNamePlural') }}
                    </a>
                </template>
            </frosted-bar>
        </div>

        <communications-automation-deliveries
            class="mt-12"
            :automation-id="automationId"
        />
    </div>
</template>
